import { useMutation } from '@tanstack/react-query';

import { damages } from '../Damages';

export const useDamagesReroute = () =>
  useMutation({ mutationFn: damages.damagesReroute });
